var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',[(_vm.group)?_c('banner-small',{attrs:{"group":_vm.group,"title":"My Answers/Acknowledgements"}}):_vm._e(),_vm._v(" "),_c('mdb-card',{staticClass:"mb-4"},[_c('mdb-card-body',[(_vm.group)?_c('answers',{attrs:{"hide-cancel":true,"group":_vm.group,"subscriptions":false},on:{"submit":_vm.submittedAnswers}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }